import { useEffect } from 'react';
import { registerUnauthorizedHandler } from '@/api/unauthorizedResponse';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { LoginPath } from '@/modules/auth/paths';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthUnauthorizedHandler = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    return registerUnauthorizedHandler(() => {
      void logout();

      if (location.pathname !== LoginPath) {
        navigate(LoginPath, {
          replace: true,
          state: { sessionExpired: true },
        });
      }
    });
  }, [location.pathname, logout, navigate]);

  return null;
};

export default AuthUnauthorizedHandler;
